import { AnimatePresence } from 'framer-motion'
import PropTypes from 'prop-types'
import Lottie from 'react-lottie-player'

import IsTypingAnimation from '../../../assets/animations/typing.json'
import { useUserContext } from '../../../context'
import { useAutoScroll } from '../hooks/useAutoScroll'
import { useDiscover } from '../hooks/useDiscover'
import AdminOnboardingSkipCard from './AdminOnboardingSkipCard'
import ActivityLogs from './assistant/ActivityLogs'
import MessageRenderer from './assistant/MessageRenderer'
import AssistantHeader from './AssistantHeader'
import DemoBookingFooter from './DemoBookingFooter'
import AivySystemMessageIcon from './icons/AivySystemMessageIcon'

const DRAWER_STYLES = {
  expanded: 'w-[850px]',
  collapsed: 'w-80',
  base: 'fixed right-0 top-0 z-30 h-screen transition-all duration-300 ease-in-out'
}

const LOTTIE_CONFIG = {
  height: 52.5,
  width: 72
}

const MessagesContent = ({ assistantMessages, assistantIsTyping }) => (
  <>
    <AnimatePresence initial={false}>
      {assistantMessages.map((message, index) => (
        <MessageRenderer key={message?.id} message={message} index={index} />
      ))}
    </AnimatePresence>
    {assistantIsTyping && (
      <Lottie
        animationData={IsTypingAnimation}
        play
        loop
        style={LOTTIE_CONFIG}
      />
    )}
    {assistantMessages.length > 0 && !assistantIsTyping && (
      <AivySystemMessageIcon />
    )}
  </>
)

MessagesContent.propTypes = {
  assistantMessages: PropTypes.array.isRequired,
  assistantIsTyping: PropTypes.bool
}

export default function AssistantDrawer() {
  const {
    assistantMessages,
    assistantIsTyping,
    assistantDetail,
    assistantFocus,
    assistantSpotlightSelector
  } = useDiscover()
  const { activeSpace } = useUserContext()

  const messagesEndRef = useAutoScroll([
    assistantMessages.length,
    assistantIsTyping
  ])
  const hasContent =
    assistantMessages.length > 0 || assistantIsTyping || assistantDetail
  const drawerClassName = `${DRAWER_STYLES.base} ${
    assistantDetail ? DRAWER_STYLES.expanded : DRAWER_STYLES.collapsed
  }`

  const isBackdropVisible =
    (assistantDetail || assistantFocus) && !assistantSpotlightSelector
  const hasCompletedOnboarding = activeSpace?.hasCompletedOnboarding

  return (
    <>
      <div
        className={`fixed inset-0 z-[10] bg-black/25 backdrop-blur-sm transition-all duration-300 ease-in-out ${
          isBackdropVisible ? 'opacity-100' : 'pointer-events-none opacity-0'
        }`}
      />
      <div className={drawerClassName}>
        <div className='flex h-full flex-col overflow-y-scroll bg-white shadow-xl'>
          <AssistantHeader />
          {/* Außerhalb des Nachrichtenbereichs, damit Auto-Scroll sie nicht
              wegschiebt */}
          <AdminOnboardingSkipCard />
          <div
            ref={messagesEndRef}
            className='relative flex flex-1 flex-col gap-y-4 overflow-y-scroll px-4 py-6'
          >
            {!hasContent && hasCompletedOnboarding && activeSpace?.id ? (
              <ActivityLogs spaceId={activeSpace.id} limit={10} />
            ) : !hasContent ? null : (
              <MessagesContent
                assistantMessages={assistantMessages}
                assistantIsTyping={assistantIsTyping}
              />
            )}
          </div>
          {/* Footer bleibt unten stehen, weil der Messages-Bereich flex-1 ist
              und selbst scrollt. */}
          <DemoBookingFooter />
        </div>
      </div>
    </>
  )
}
